import { createContext, useState, type PropsWithChildren } from "react";

import { defaultWhitelabelBrand, whitelabelBrands, type WhitelabelBrand } from "@/configs/whitelabel";

const WhitelabelBrandContext = createContext<WhitelabelBrand>(defaultWhitelabelBrand);

const WhitelabelBrandProvider = ({ children }: PropsWithChildren) => {
  const [whitelabelBrand, setWhitelabelBrand] = useState<WhitelabelBrand>(defaultWhitelabelBrand);

  const currentWhitelabelBrand = whitelabelBrands.find((brand) => brand.urls.includes(location.hostname));
  if (currentWhitelabelBrand && currentWhitelabelBrand !== whitelabelBrand) setWhitelabelBrand(currentWhitelabelBrand);

  return <WhitelabelBrandContext value={whitelabelBrand}>{children}</WhitelabelBrandContext>;
};

export { WhitelabelBrandContext, WhitelabelBrandProvider };

export default WhitelabelBrandProvider;
